import { render } from "./apiDemo.vue?vue&type=template&id=530c32a0"
import script from "./apiDemo.vue?vue&type=script&lang=js"
export * from "./apiDemo.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__